/**
 * Custom JS — Borderline Theme
 * Loaded after theme.js. Uses event delegation.
 */
(function () {
  'use strict';

  var initialized = false;

  function closeAllNavs() {
    document.querySelectorAll('.header-navigation .menu-item.nav-open').forEach(function (el) {
      el.classList.remove('nav-open');
      var a = el.querySelector(':scope > .menu-link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }

  function closeSiblingNavs(item) {
    var siblings = item.parentNode.querySelectorAll(':scope > .menu-item.nav-open');
    siblings.forEach(function (el) {
      el.classList.remove('nav-open');
      var a = el.querySelector(':scope > .menu-link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }

  function initClickNav() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('click', function (e) {
      if (window.innerWidth < 992) return;

      var link = e.target.closest('.header-navigation > .menu-item > .menu-link.has-children');
      if (!link) {
        // Clicked outside nav → close all
        if (!e.target.closest('.header-navigation')) {
          closeAllNavs();
        }
        return;
      }

      e.preventDefault();

      var item = link.parentNode;
      var isOpen = item.classList.contains('nav-open');

      if (isOpen) {
        // OPEN: click toggles the panel closed.
        item.classList.remove('nav-open');
        link.setAttribute('aria-expanded', 'false');
      } else {
        // CLOSED: click toggles the panel open and closes siblings.
        closeSiblingNavs(item);
        item.classList.add('nav-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllNavs();
    });
  }

  document.addEventListener('DOMContentLoaded', initClickNav);
})();
